import React from "react";
import { Container } from "../components/ui/Container";
import { Footer } from "../components/Footer";

const SUPPORT_EMAIL = "support@knooth.com";

const Support = () => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard blocked — fall back silently
    }
  };

  const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
    SUPPORT_EMAIL
  )}`;
  const outlookUrl = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(
    SUPPORT_EMAIL
  )}`;

  return (
    <div id="top" className="min-h-screen bg-[#FBFBFD]">
      <main className="pt-[220px] md:pt-[280px]">
        <Container>
          <div className="text-center">
            <h1
              className="text-6xl md:text-8xl lg:text-[96px] font-[900] tracking-[-0.02em] leading-none text-transparent bg-clip-text pb-2"
              style={{
                backgroundImage:
                  "linear-gradient(180deg, #31220D 57%, #666666 100%)",
              }}
            >
              Get in touch
            </h1>
          </div>

          <div className="mt-[24px] max-w-[720px] mx-auto text-center">
            <p className="text-[18px] md:text-[20px] leading-[160%] text-[#666666]">
              Found a bug, have a question, or an idea to share?
              <br />
              We'd love to hear from you — drop us a note any time.
            </p>

            <div className="mt-[72px] flex flex-col items-center gap-[8px]">
              <button
                type="button"
                onClick={handleCopy}
                className="group inline-flex items-center gap-[12px] rounded-full px-[28px] h-[56px] text-white font-bold text-[20px] md:text-[22px] hover:shadow-lg transition-all border-none leading-none"
                style={{
                  background:
                    "linear-gradient(180deg, #2F00EC 57%, #C8A5FF 100%)",
                }}
                aria-label={`Copy ${SUPPORT_EMAIL} to clipboard`}
              >
                <span>{SUPPORT_EMAIL}</span>
                <span className="text-[14px] font-semibold opacity-60">
                  {copied ? "Copied ✓" : "Copy"}
                </span>
              </button>

              <div className="flex flex-wrap items-center justify-center gap-x-[20px] gap-y-[8px] text-[14px] text-[#666666]">
                <span>Or open in:</span>
                <a
                  href={gmailUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold text-[#2B00FF] hover:underline"
                >
                  Gmail
                </a>
                <a
                  href={outlookUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold text-[#2B00FF] hover:underline"
                >
                  Outlook
                </a>
              </div>

              <p className="mt-[32px] text-[13px] text-[#666666]">
                We read every message and reply personally.
              </p>
            </div>
          </div>

          <div className="h-[160px] md:h-[200px]" />
        </Container>
      </main>

      <Footer />
    </div>
  );
};

export { Support };
